import React from 'react'
import logo from '../assets/logo-vermelho.png'
import { Link } from 'react-router-dom'
const Splash = () => {
    return (
        <div className="splash">
            <Link to="begin">
                <img src={logo} alt="logo Kinema" />
            </Link>
        </div>
    )
}

export default Splash
